import React from 'react';
import PropTypes from 'prop-types';
import Button from 'widgets/Button';
import Icon from 'components/Icon';
import colors from 'assets/styles/jsVariables/colors';
import { DESKTOP_VIEW } from 'libs/windowDimension';
import './SideLabel.scss';

const style = {
  buttonStyle: {
    '&:hover': {
      background: 'white',
    }
  },
  buttonLabelStyle: {
    textTransform: 'none',
    fontSize: '14px',
    letterSpacing: '0px'
  }
};

function SideLabel(props) {
  const {
    disabled, iconSize, windowDimension, editLabel, onClick
  } = props;
  return (
    <Button
      color="primary"
      cssStyles={{
        root: style.buttonStyle,
        label: style.buttonLabelStyle
      }}
      onClick={onClick}
      style={{ minWidth: 40, padding: 0 }}
      disabled={disabled}
    >
      <div className="EditableLabel__SideLabel">
        {
          !DESKTOP_VIEW(windowDimension) &&
          <Icon
            name="mode-edit"
            fill={disabled ? colors.lightGrey : colors.lighterCyan}
            style={{
              height: iconSize,
              width: iconSize,
              marginBottom: -3,
              marginRight: 10
            }}
          />
        }
        {DESKTOP_VIEW(windowDimension) && editLabel}
      </div>
    </Button>
  );
}

export default SideLabel;

SideLabel.propTypes = {
  disabled: PropTypes.bool.isRequired,
  iconSize: PropTypes.number.isRequired,
  windowDimension: PropTypes.object.isRequired,
  editLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/EditableLabel/SideLabel.jsx